import { enterTwoFactorCode } from "@/api/twofactorauth";
import useRecaptcha from "@/hooks/useRecaptcha";
import { useState } from "react";

export default function useEnterTwoFactor({
  onCompleted,
}: {
  onCompleted?: () => void;
}) {
  const { onSubmitWithReCAPTCHA } = useRecaptcha();
  const [isEntering, setIsEntering] = useState(false);
  const [isError, setIsError] = useState(false);
  const handleEnter = async (code: string) => {
    setIsEntering(true);
    try {
      const recaptcha = await onSubmitWithReCAPTCHA();
      await enterTwoFactorCode(code, recaptcha);
      onCompleted && onCompleted();
    } catch {
      setIsError(true);
    }
    setIsEntering(false);
  };
  return { isEntering, isError, handleEnter };
}
